
exports.install = function (Vue, options) {
    Vue.prototype.checkBtnPermiss = function (path = '', funcStr = '') {
        let permissList = JSON.parse(sessionStorage.getItem("permiss")) || [];
        if (path && funcStr) {
            let permiss = `button-${path.slice(1, path.length)}/${funcStr}`
            let canIuse = false
            permissList.forEach(item => {
                if (item.resourceCode === permiss) {
                    canIuse = true
                    return
                }
            });
            return canIuse
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/checkBtnPermiss.js